import React from 'react'
import { PageTitle } from '_metronic/layout/core'
import { ClientSideTable } from 'Presentation/Components/Table'
import useViewModel from './ViewModel'

const BillingInvoiceView: React.FC = () => {
	const { data, TABLE_CONFIGS } = useViewModel()

	return (
		<ViewPageTitle>
			<div className="row">
				<div className="col-12">
					<div className="card">
						{/* begin:: Body */}
						<div className="card-body px-0 py-2 border border-kumopack-grey-200 border-radius-16px">
							<ClientSideTable
								pagination
								isGrey
								items_per_page={10}
								columns={TABLE_CONFIGS}
								data={data}
							/>
						</div>
						{/* end:: Body */}
					</div>
				</div>
			</div>
		</ViewPageTitle>
	)
}

const ViewPageTitle: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	return (
		<React.Fragment>
			<PageTitle
				breadcrumbs={[
					{
						title: 'Billing',
						path: '/billing',
						isActive: false,
						isSeparator: false,
					},
					{
						title: 'Tax Invoice Subscription',
						path: '#',
						isActive: true,
						isSeparator: false,
					},
				]}>
				ใบกำกับภาษี Subscription
			</PageTitle>

			{children}
		</React.Fragment>
	)
}

export default BillingInvoiceView
